import { type RouteRecordRaw } from 'vue-router'

import { useApplicationCfgStore } from '../applicationCfg/applicationCfg.store'
import { useFestivalStore } from '../festival/festival.store'
import { useProgEventStore } from '../progEvent/progEvent.store'
import { useMenuEntriesStore } from './menuEntries.store'

export const MenuRouter: RouteRecordRaw[] = [
  {
    path: '/menuEntries',
    component: async () => import('./MenuEntries.vue'),
    async beforeEnter() {
      await Promise.all([
        useApplicationCfgStore.getState().loadApplicationCfg(),
        useFestivalStore.getState().loadFestival(),
        useProgEventStore.getState().list(),
        useMenuEntriesStore.getState().getAllContent(),
        useMenuEntriesStore.getState().getAllChoices(),
      ])
    },
  },
]
